import React, { useRef } from "react";
import "./reviews.scss";

import ArrowLeft from "../../images/ArrowLeft2.svg";
import ArrowRight from "../../images/ArrowRight2.svg";
import RatingIcon from "../../images/rating_ic.svg";
import Bake from "../../images/Bake.jpeg";
import Make from "../../images/Make.jpeg";
import Apai from "../../images/Apai.jpeg";

const Reviews = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const scrollAmount = direction === 'left' ? -420 : 420;
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <div className="reviews">
      <div className="review_inner">
        <div className="reviews_header">
          <div className="reviews_header_title">
            Курстардан өткен студенттердің <span>пікірлері</span>
          </div>
          <div className="review_header_arrows">
            <button className="review_arrow" onClick={() => scroll('left')}>
              <img src={ArrowLeft} alt="Back" />
            </button>
            <button className="review_arrow" onClick={() => scroll('right')}>
              <img src={ArrowRight} alt="Next" />
            </button>
          </div>
        </div>

        <div className="reviews_cards_container_outside">
          <div ref={scrollRef} className="reviews_cards_container">
            {/* Максат */}
            <div className="review_card">
              <div className="review_card_student">
                <div className="student_img_wrapper">
                  <img src={Make} alt="Maksat" />
                </div>
                <div className="student_info">
                  <div className="name">Уксикбаев Максат</div>
                  <div className="subtitle">"Android қосымшалар" курсы</div>
                </div>
              </div>
              <div className="review_card_text">
                Пайдалы курс, материалдар өте көп және түсінікті. Қызықты ақпараттар мен практикалық тапсырмалар өте көп болды.
              </div>
              <div className="review_rating">
                <img src={RatingIcon} alt="rating" />
                <div className="rating">
                  5 <span>/5</span>
                </div>
              </div>
            </div>

            {/* Эльмира */}
            <div className="review_card">
              <div className="review_card_student">
                <div className="student_img_wrapper">
                  <img src={Apai} alt="Elmira" />
                </div>
                <div className="student_info">
                  <div className="name">Абдрашова Эльмира</div>
                  <div className="subtitle">"Web бағдарламалау" курсы</div>
                </div>
              </div>
              <div className="review_card_text">
                Оқытушылар өз ісінің маманы. Дәрістер өте қызықты өтті, алған білімімді қазір жобаларымда қолданып жүрмін.
              </div>
              <div className="review_rating">
                <img src={RatingIcon} alt="rating" />
                <div className="rating">
                  5 <span>/5</span>
                </div>
              </div>
            </div>

            {/* Берик (Бос емес болса да үлгі ретінде) */}
            <div className="review_card">
              <div className="review_card_student">
                <div className="student_img_wrapper">
                  <img src={Bake} alt="Berik" />
                </div>
                <div className="student_info">
                  <div className="name">Нурымбетов Берик</div>
                  <div className="subtitle">"Java программалау" курсы</div>
                </div>
              </div>
              <div className="review_card_text">
                Тамаша курс. Қызықты тапсырмалар және өте көп ақпарат. Мұғалімдер өте білікті. Барлық дәрістер бір демде өтті.
              </div>
              <div className="review_rating">
                <img src={RatingIcon} alt="rating" />
                <div className="rating">
                  5 <span>/5</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;